import { defineStore } from "pinia";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
import { API_RESPONSE_SUCCESS } from "@/data/constants";
const apiGatewayRepository = RepositoryFactory.get('apiGateway');
import router from "@/router";
import i18n from '@/i18n/main'

const { t } = i18n.global;
export const useAuthStore = defineStore('authStoreId', {
    state: () => {
        return {
            isAuth: false,
            isLoading: false,
        }
    },
    actions: {
        async checkSession() {
            try {
                this.isLoading = true;
                const ssid = localStorage.getItem('HVCHUBSYNCHSSID');
                const authId = localStorage.getItem('auth_id');

                if (ssid === null || authId === null || ssid.length !== 40 || authId.length !== 40) {
                    this.isAuth = false;
                    this.isLoading = false;
                    return this.isAuth;
                }
                const response = await apiGatewayRepository.checkSession();
                this.isAuth = (typeof response.data === 'object' && response.data.result === API_RESPONSE_SUCCESS)
            } catch (e) {
                this.isLoading = false;
                this.isAuth = false;
                this.clearSession();
            }
            this.isLoading = false;
            return this.isAuth;
        },
        async validateSession(){
            if (!await this.checkSession()) {
                swal(
                    t('TITLE_SESSION_EXPIRED_ERROR'),
                    t('TEXT_SESSION_EXPIRED_ERROR'),
                    "error"
                );
                router.push("/login");
                return false;
            }
            return true;
        },
        clearSession() {
            window.localStorage.clear();
        },
    }
});